import { render, staticRenderFns } from "./TsPageHero.vue?vue&type=template&id=469d1232"
import script from "./TsPageHero.vue?vue&type=script&lang=ts"
export * from "./TsPageHero.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports